import React from 'react';
import * as styled from './styled/CompUnit.styled';

function getAdminLink(unitID: number) {
    return `https://admin.vacasa.com/admin/dashboard/units/edit?UnitID=${unitID}`;
}

export const VacasaComps: React.FC<{
    unitIds: number[];
}> = ({ unitIds }) => {
    if (!unitIds || unitIds.length === 0 || unitIds[0] === 0)
        return (
            <styled.CompUnit>
                <span>No Vacasa comps available.</span>
            </styled.CompUnit>
        );
    const htmlComps = unitIds.map((unitID) => {
        return (
            <li key={unitID}>
                <a target="_blank" href={getAdminLink(unitID)}>
                    {' '}
                    {unitID}
                </a>
            </li>
        );
    });
    return (
        <styled.CompUnit>
            <span>
                Vacasa comps: <ul>{htmlComps}</ul>
            </span>
        </styled.CompUnit>
    );
};
